import routes from '@/modules/prescription/prescription-routes';
import store from '@/modules/prescription/prescription-store';

export default {
  routes,
  store
};
